import React from 'react';
import { Edit, useRedirect, TabbedShowLayout, Tab} from 'react-admin';
import { AppReferenceManyField } from "components/list/AppReferenceManyField";

import { OwnerCompanyDataForm } from '../forms/OwnerCompanyDataForm';
import { SimpleFormAdv } from '../../../components/forms/SimpleFormAdv';
import { DocumentTemplateList } from 'components/DocumentTemplates';
import { DefaultDocumentTemplateType } from 'entities/DocumentTemplateType';
import Card from '@material-ui/core/Card';


export const OwnerCompanyDataEdit = (props) => {
    const redirect = useRedirect();

    const onSuccess = () => {
        redirect(props.basePath);
    };

    const toolbarCompProps = {
		useSaveButtonEx: true,
		saveButtonExProps: { onSuccess },
	};

    return (
        <TabbedShowLayout style={{paddingBottom: 8}} basePath={props.basePath}>
            <Tab label="tab.geneneral.name" >
            <Edit {...props} undoable={false}>
                <SimpleFormAdv toolbarCompProps={toolbarCompProps}>
                    <OwnerCompanyDataForm />
                </SimpleFormAdv>
            </Edit>
            </Tab>
            <Tab label="tab.document-template-default.name" path="document-templates">
                <Card>
                    <AppReferenceManyField label={false} fullWidth reference="document-templates" filter={{"type": DefaultDocumentTemplateType.invoice_template}}
                    >
                        <DocumentTemplateList isDefaultInvoiceTeplateWithNullTerminal={true} {...props}/>
                    </AppReferenceManyField>
                </Card>
            </Tab>
        </TabbedShowLayout>
    );
};
